import PersonalInformationForm from "../forms/pageForms/personalInformationForm";
import TaskComplete from "../common/taskComplete";
import { useTranslation } from "react-i18next";

export default function PersonalInformation({
  user,
  userData,
  shake,
  updatePage,
}) {
  const { t } = useTranslation();
  return (
    <>
      {/* {userData.empInfo.ssn ? (
        <section className="main-section">
          <h2>Personal Information</h2>
          <section className="main-section-content">
            <TaskComplete
              pageTitle="Personal Information"
              nextLink="phase2-general"
            />
          </section>
        </section>
      ) : (
        <> */}
          {/* Page Instructions Section  */}
          <section className="main-section">
            <h2>{t("personalInfo.title")}</h2>
            <div className="main-section-content text-start">
              <p>{t("personalInfo.instructions")}</p>
              <p>{t("personalInfo.requiredFieldNote")}</p>
            </div>
          </section>

          {/* Form Section  */}
          <section className="main-section">
            <h2>{t("personalInfo.formTitle")}</h2>
            <div className="main-section-content">
              <PersonalInformationForm
                updatePage={updatePage}
                shake={shake}
                nextLink="phase2-general"
                user={user}
                userData={userData}
              />
            </div>
          </section>
        </>
      // )}
    // </>
  );
}
